import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import { ExpandableText } from '@bibliocommons/expandable';
import { bibShape, shelfItemShape, ugcCommentShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { allowFreeText } from '@bibliocommons/utils-user';

import CommentUGCEditor from '../UGCEditors/CommentUGCEditor';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';

export default class CommentDisplay extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('openEditor', 'closeEditor');

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return this.state.showEditor && (
      <CommentUGCEditor
        bib={this.props.bib}
        shelfItem={this.props.shelfItem}
        handleClose={this.closeEditor}
        existingComment={this.props.comment}
        commentsTransactions={this.props.commentsTransactions}
        shelfTransactions={this.props.shelfTransactions}
        commentsActions={this.props.commentsActions}
        shelfActions={this.props.shelfActions} />
    );
  }

  renderActions() {
    const { commentsActions, commentsTransactions, owner, comment, bib } = this.props;

    if (owner.get('loggedIn')) {
      const commentId = comment.get('id');
      const metadataId = comment.get('metadataId');
      const handleRemove = () => commentsActions.removeComment({ metadataId, commentId });
      const isRemoving = commentsTransactions.getIn([metadataId, commentId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_comment" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_comment" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={allowFreeText(owner) ? this.openEditor : undefined}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage} />
      );
    }

    return null;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-comment-display">
        <ExpandableText text={this.props.comment.get('comment')} />
        {this.renderActions()}

        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

CommentDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  comment: ugcCommentShape.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/CommentDisplay/CommentDisplay.jsx